import { render } from "./show.vue?vue&type=template&id=5e4b6935&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import "@/css/view.css?vue&type=style&index=0&id=5e4b6935&scoped=true&lang=css"
import "@/css/information.css?vue&type=style&index=1&id=5e4b6935&scoped=true&lang=css"
import "./show.vue?vue&type=style&index=2&id=5e4b6935&scoped=true&lang=css"
import "./show.vue?vue&type=style&index=3&id=5e4b6935&lang=css"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4b6935"]])

export default __exports__